"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
exports.isBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
